import { User } from '../../models/user.types';
import { Cart } from '../../models/cart.types';

export const impactTrackSignup = (user: User, cart: Cart): void => {
  if (window.ire) {
    const { couponName, isCouponApplied } = cart.priceSummary;
    window.ire('trackConversion', IMPACT_ACCOUNT_ID, {
      orderId: user.subscriptionId,
      customerId: user.id.toString(),
      customerEmail: user.email,
      customerStatus: 'active',
      currencyCode: 'USD',
      orderPromoCode: isCouponApplied ? couponName : '',
      items: [{
        subTotal: cart.priceSummary.total,
        category: user.plan,
        sku: cart.plan,
        quantity: 1,
        name: user.plan,
      }],
    }, {
      verifySiteDefinitionMatch: true,
    });
  }
};
